import { Action } from '@ngrx/store';

import { CurtainChangedEvent } from '../../../../shared/events/cutains-changed.event';

export enum CurtainActionTypes {
  SELECT_CURTAIN = '[Curtain] Select Curtain',
  NO_CURTAIN = '[Curtain] No Curtain',
  UPDATE_CURTAIN = '[Curtain] Update Curtain',
}

export class SelectCurtain implements Action {
  readonly type = CurtainActionTypes.SELECT_CURTAIN;

  constructor(public payload: CurtainChangedEvent) {}
}

export class NoCurtain implements Action {
  readonly type = CurtainActionTypes.NO_CURTAIN;
}

export class UpsertCurtain implements Action {
  readonly type = CurtainActionTypes.UPDATE_CURTAIN;

  constructor(public payload: CurtainChangedEvent) {}
}

export type CurtainActionsUnion = SelectCurtain | NoCurtain | UpsertCurtain;
